<template>
  <div>
    <VueSlider
      ref="sliderRef"
      v-model="rangeArray"
      :min="customMaxRange.min"
      :max="customMaxRange.max"
      :drag-on-click="true"
      :contained="true"
      :silent="true"
      :disabled="disabled"
      :dot-attrs="{ 'aria-label': $t('Adjust value') }"
      tooltip="none"
      @change="onInput($event)"
      @drag-end="onEnd($event)"
    />
  </div>
</template>

<script lang="ts">

import type { ValueArray, ValueRange, ValueRangeOptional } from '~~/types/ValueRange';
import VueSlider from 'vue-3-slider-component';

// TODO - check if these imports are still needed once page is functional

interface GetValue {
  (): [number, number];
}
interface Slider extends HTMLElement {
  getValue: GetValue
}

export default defineComponent({
  name: 'RangeSlider',
  components: { VueSlider },
  props: {
    currentRange: {
      type: Object as PropType<ValueRangeOptional>,
      required: true,
    },
    maxRange: {
      type: Object as PropType<ValueRange>,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['input', 'end'],
  setup(props, { emit }) {

    const sliderRef = ref<Slider | null>(null);

    const rangeArray = computed(() => {

      const min = props.currentRange.min ?? props.maxRange.min;
      const max = props.currentRange.max ?? props.maxRange.max;

      return [min, max];
    
    });

    const customMaxRange = computed(() => {

      const min = props.maxRange.min;
      let max = props.maxRange.max;

      if (min === max) {

        max = max + 1; // needed to prevent error when clicking on slider (even when it is disabled)
      
      }

      return { min, max };
    
    });

    function arrayToRange(array: ValueArray): ValueRange {

      return { min: array[0], max: array[1] };
    
    }

    function onInput(values: ValueArray): void {

      emit('input', arrayToRange(values));
    
    }

    function onEnd(): void {

      const values = sliderRef.value?.getValue();
      const range = values ? arrayToRange(values) : props.maxRange;
      emit('end', range);
    
    }

    return { rangeArray, onInput, onEnd, customMaxRange, sliderRef };
  
  },
});

</script>

<style lang="scss" scoped>
:deep(*) {
  .vue-slider-process {
    @apply bg-EXPONDO-primary-60;
  }

  .vue-slider-dot-handle-focus {
    box-shadow: 0 0 1px 2px var(--c-primary-60);
  }
}
</style>
